/******************************************
 *  Author : Suraj Sharma
 *  Created On : Mon Dec 28 2020
 *  File : index.jsx
 *******************************************/
import Signup from './Signup';

export default Signup;